import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { CookieService } from 'angular2-cookie';
import { Funciones } from '../models/funciones.model';
import * as CryptoJS from 'crypto-js';

export class GlobalFunctions {

    constructor(
        private _router?: Router,
        private _cookie?: CookieService
    ) { }

    //#region Metodos 

    // * Subrutina  empresaInfo
    empresaInfo(): any {
        const empresaInfo: any = {
            logo: 'http://172.105.149.128/hedonista/HEDONISTA-FINAL.jpg',
            nombre: 'HEDONISTA BAR',
            nombreCorto: 'HEDONISTA',
            texto:
                'Estamos en la búsqueda del placer y ¿qué mejor lugar para encontrarlo? Somos un bar de barrio en el corazón de zona 4.',
        };
        return empresaInfo;
    }

    async swalError(): Promise<any> {
        await Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Sin servicio',
            returnInputValueOnDeny: false,
        });
    }

    swalUpdateConfirmation(callback: any): any {
        Swal.fire({
            title: '¿Desea actualizar este registro?',
            text: '',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: '¡Sí, actualizalo!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                callback();
            }
        });
    }

    swalDeleteConfirmation(callback: any): any {
        Swal.fire({
            title: '¿Desea eliminar este registro?',
            text: '¡No será capaz de revertirlo!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: '¡Sí, eliminalo!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                callback();
            }
        });
    }

    // * dateFunctionFromObject

    dateFunctionFromObject(param): string {
        let dateCompleted = '';
        if (typeof (param) == 'string') {
            return  param;
        } else {
            const date = Number(param.date);
            const month = Number(param.month) + 1;
            const year = Number(param.year);
            if (month < 10 && date < 10) {
                dateCompleted = year + '-0' + month + '-0' + date;
            }
            if (month < 10 && date === 10) {
                dateCompleted = year + '-0' + month + '-' + date;
            }
            else if (month < 10 && date > 10) {
                dateCompleted = year + '-0' + month + '-' + date;
            }
            else if (month >= 10 && date < 10) {
                dateCompleted = year + '-' + month + '-0' + date; 
            }
            else if (month >= 10 && date === 10) {
                dateCompleted = year + '-' + month + '-' + date; 
            }
            else if (month >= 10 && date > 10) {
                dateCompleted = year + '-' + month + '-' + date; 
            }
            return dateCompleted;
        }
    }

    // * Subrutina dateFunction. Retorna hora y/o fecha.
    dateFunction(param): any {
        const today = new Date();
        const day = today.getDate();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();
        let date;

        if (month < 10 && day < 10) {
            date = year + '-0' + month + '-0' + day;
        }
        if (month < 10 && day === 10) {
            date = year + '-0' + month + '-' + day;
        }
        else if (month < 10 && day > 10) {
            date = year + '-0' + month + '-' + day;
        }
        else if (month >= 10 && day < 10) {
            date = year + '-' + month + '-0' + day; 
        }
        else if (month >= 10 && day === 10) {
            date = year + '-' + month + '-' + day; 
        }
        else if (month >= 10 && day > 10) {
            date = year + '-' + month + '-' + day; 
        }

        const hour =
            today.getHours() +
            '-' +
            today.getMinutes() +
            '-' +
            today.getSeconds();
        const dateNhour = date + ' ' + hour;
        switch (param) {
            case 'date':
                return date;
            case 'hour':
                return hour;
            case 'dateNhour':
                return dateNhour;
        }
    }

    // * Subrutina para validar el id, y crear codigo de 5 cifras
    genCodeMaxFiveLength(id: number): any {
        id = id + 1;
        const idLength = id.toString().length;
        switch (idLength) {
            case 1:
                return '0000' + id;
            case 2:
                return '000' + id;
            case 3:
                return '00' + id;
            case 4:
                return '0' + id;
            case 5:
                return id;
            case 6:
                return 'El código no puede ser mayor o igual a 6 cifras.';
        }
    }

    // * Subrutina para validar el id, y crear codigo de 5 cifras
    genCodeMaxFourLength(id: number): any {
        id = id + 1;
        const idLength = id.toString().length;
        switch (idLength) {
            case 1:
                return '000' + id;
            case 2:
                return '00' + id;
            case 3:
                return '0' + id;
            case 4:
                return id;
            case 5:
                return 'El código no puede ser mayor o igual a 5 cifras.';
        }
    }

    genCookieTime(): any {
        const d = new Date();
        const year = d.getFullYear();
        const month = d.getMonth();
        const day = d.getDate();
        const c = new Date(year + 1, month, day);
        const opts = { expires: c };
        return opts;
    }

    encryptAESValue(value: any, key: string): string {
        return CryptoJS.AES.encrypt(value, key).toString();
    }

    decryptAESValue(value: any, key: string): string {
        const bytes = CryptoJS.AES.decrypt(value, key);
        const originalText = bytes.toString(CryptoJS.enc.Utf8);
        return originalText;
    }

    rot13(s: string): string {
        return s.replace(/[A-Z]/gi, c =>
            'NOPQRSTUVWXYZABCDEFGHIJKLMnopqrstuvwxyzabcdefghijklm'[
            'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.indexOf(c)]);
    }

    decimalToHex(s: string): string {
        const array = s.split('.');
        const arrayEncrypting = array.map(e => Number(e).toString(16));
        const arrayEncrypted = arrayEncrypting.join('.');
        return arrayEncrypted;
    }

    hexToDecimal(s: string): string {
        const array = s.split('.');
        const arrayEncrypting = array.map(e => parseInt(e, 16));
        const arrayEncrypted = arrayEncrypting.join('.');
        return arrayEncrypted;
    }
    //#endregion

    //#endregion
}

export const MY_DATE_FORMATS = {
    parse: {
        dateInput: 'DD-MM-YYYY',
    },
    display: {
        dateInput: 'DD MMM, YYYY',
        monthYearLabel: 'MMMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY'
    },
};

